import VehiclesSubscriptionsTable from 'src/features/subscriptions/components/tables/VehiclesSubscriptionsTable';

const Subscriptions = () => <VehiclesSubscriptionsTable />;

export default Subscriptions;
